module.exports = __webpack_public_path__ + "static/media/toll-service-en.aebe59f7.mp4";